<template>
  <div>
    <Topheader :keyword="keyword"></Topheader>
    <div class="w1100">
      <div class="info-body">
        <!--头像信息-->
        <div class="head-body">
          <div class="head-img-body">
            <div class="head-img">
              <img :src="allInfo.head_url" alt="">
            </div>
            <i class="el-icon-camera-solid" @click="$router.push('/editHead')"></i>
          </div>
          <div class="head-info">
            <div class="title">{{allInfo.name}}</div>
            <div class="head-count">
              <span class="word">{{allInfo.posts}}</span>
              <span class="wordTit">Post</span>
              <span class="word">{{allInfo.linkers}}</span>
              <span class="wordTit">Linkers</span>
              <span class="word">{{allInfo.follows}}</span>
              <span class="wordTit">Followers</span>
            </div>
          </div>
        </div>
        <!--基本信息-->
        <div class="jb-info-body">
          <div class="jb-title">
            <div class="title">个人基本</div>
            <router-link
              :to="{name:'personBasic',params:{name:allInfo.name,web_url:allInfo.web_url,achievement:allInfo.achievement,state:allInfo.state,province_id:allInfo.province_id,city_id:allInfo.city_id}}"
              class="edit-btn"
            >编辑</router-link>
          </div>
          <div class="jb-spk">说明居住城市、真实姓名、个人网站、成就荣耀；</div>
          <div class="jb-list-body">
            <img src="../../static/icon/city.png" alt="">
            <div class="title2-img">Live in
              <span class="balck">{{allInfo.area_text}}</span>
              from {{allInfo.state_text}}
            </div>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/name.png" alt="">
            <div class="title2-img">You name is
              <span class="balck">{{allInfo.name}}</span>
            </div>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/reg-time.png" alt="">
            <div class="title2-img">Registration time in
              <span class="balck">{{allInfo.create_time}}</span>
            </div>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/web-url.png" alt="">
            <div class="title2-img" @click="common.openUrl(allInfo.web_url)">
              <span class="balck">{{allInfo.web_url}}</span>can understand you.
            </div>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/chengjiu.png" alt="">
            <div class="title2-img">Your achievement is
              <span class="balck">{{allInfo.achievement}}</span>
            </div>
          </div>
        </div>
        <!--安全已健康-->
        <div class="jb-info-body">
          <div class="jb-title" style="padding-bottom:23px">
            <div class="title">安全与健康</div>
            <router-link
              :to="{name:'personSafetyAndHealth',params: {email:allInfo.email,tel:allInfo.tel}}"
              class="edit-btn"
            >编辑</router-link>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/zhanghu.png" alt="">
            <div class="title-img">账户</div>
          </div>
          <div class="an-jk-list">
            <div class="title">邮箱</div>
            <div class="info">{{allInfo.email}}</div>
          </div>
            <div class="an-jk-list">
                <div class="title">手机</div>
                <div class="info">{{allInfo.tel}}</div>
            </div>
          <div class="an-jk-list">
            <div class="title">密码</div>
            <div class="info">···············</div>
          </div>
        </div>
        <!--数据-->
        <div class="jb-info-body">
          <div class="jb-list-body">
            <img src="../../static/icon/shuju.png" alt="">
            <div class="title-img">数据</div>
          </div>
          <div class="an-jk-list">
            <div class="title">研究机构</div>
            <div class="info">未开放</div>
          </div>
          <div class="an-jk-list">
            <div class="title">商业APP</div>
            <div class="info">未开放</div>
          </div>
          <div class="an-jk-list">
            <div class="title">公益APP</div>
            <div class="info">未开放</div>
          </div>
          <div class="an-jk-list">
            <div class="title">设备</div>
            <div class="info">未开放</div>
          </div>
          <div class="an-jk-list">
            <div class="title">政府部门</div>
            <div class="info">未开放</div>
          </div>
          <div class="an-jk-list">
            <div class="title">组织机构</div>
            <div class="info">未开放</div>
          </div>
          <div class="an-jk-list">
            <div class="title">个人团体</div>
            <div class="info">未开放</div>
          </div>
        </div>
        <!--向访问者展示-->
        <div class="jb-info-body">
          <div class="jb-title" style="padding-bottom:23px">
            <div class="title">向访问者展示</div>
            <router-link
              :to="{name:'personShowVisiters',params:{
            zyly:allInfo.zyly,
            zyly_year:allInfo.zyly_year,
            jnk:allInfo.jnk,
            swfu:allInfo.swfu,
            swfu_year:allInfo.swfu_year,
            introduce:allInfo.introduce,
            welcome:allInfo.welcome
            }}"
              class="edit-btn"
            >编辑</router-link>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/zhiye.png" alt="">
            <div class="title-img">职业/研究领域</div>
            <div class="title-spk">用于推荐引用和搜索附言的展示</div>
          </div>
          <div class="show-content">{{allInfo.zyly}} - {{allInfo.zyly_year}}</div>
          <div class="jb-list-body">
            <img src="../../static/icon/jnk.png" alt="">
            <div class="title-img">技能快</div>
            <div class="title-spk">用于推荐引用</div>
          </div>
          <div class="show-content">{{allInfo.jnk}}</div>
          <div class="jb-list-body">
            <img src="../../static/icon/shangye.png" alt="">
            <div class="title-img">商业服务</div>
            <div class="title-spk">用于搜索副标的展示</div>
          </div>
          <div class="show-content">{{allInfo.swfu}} - {{allInfo.swfu_year}}</div>
          <div class="jb-list-body">
            <img src="../../static/icon/jieshao.png" alt="">
            <div class="title-img">介绍语</div>
            <div class="title-spk">用于个人主页和搜索的展示</div>
          </div>
          <div class="show-content">{{allInfo.introduce}}</div>
          <div class="jb-list-body">
            <img src="../../static/icon/zhaohu.png" alt="">
            <div class="title-img">招呼语</div>
            <div class="title-spk">用于推荐引用</div>
          </div>
          <div class="show-content">{{allInfo.welcome}}</div>
        </div>
        <!--关键词-->
        <div class="jb-info-body keyword-body">
          <div class="jb-title" style="padding-bottom:23px">
            <div class="title">索引种子</div>
            <router-link
              :to="{name:'personkeywords',params:{keyword:allInfo.keyword}}"
              class="edit-btn"
            >编辑</router-link>
          </div>
          <div class="jb-list-body">
            <img src="../../static/icon/keyword.png" alt="">
            <div class="title-img">关键词</div>
            <div class="title-spk">用于woshuoxia搜索的蜘蛛爬抓</div>
          </div>
          <div class="show-content">{{allInfo.keyword}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topheader from "../components/header"; //上传图片
export default {
  name: "infoEditInfo",
  components: {
    Topheader
  },
  data() {
    return {
      keyword: "",
      allInfo: {}
    };
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#CBCBCB");
  },
  created() {
    this.getInfo();
  },
  //方法定义
  methods: {
    //获取信息
    getInfo() {
      let _this = this;
      _this.common.request("api/user/allInfo", {}, function(res) {
        if (res.status == 200) {
          _this.allInfo = res.data;
          let userInfo = {
            email: _this.allInfo.email,
            head_url: _this.allInfo.head_url,
            name: _this.allInfo.name
          };
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          console.log(res);
        }
      });
    }
  }
};
</script>

<style scoped lang='less' rel="stylesheet/less">
@import "../assets/css/index.less";

.info-body {
  background-color: white;
  margin-top: 80px;
  margin-bottom: 80px;
  .head-body {
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #dbdbdb;
    height: 75px;
    padding: 20px;
    .head-img-body {
      position: relative;
      .head-img {
        .imgNoCut(160px;153px);
        bottom: 80px;
      }
      i {
        width: 25px;
        height:18px;
        position: absolute;
        right: 5px;
        bottom: 10px;
        color: white;
        font-size: 21px;
        cursor: pointer;
      }
    }
    .head-info {
      margin-left:22px;
      .title {
        font-size: 32px;
        font-weight: bold;
        color: #575757;
        margin-bottom: 12px;
      }
      .head-count {
        font-size: 18px;
        .word {
          color: #585858;
          margin-right: 14px;
        }
        .wordTit {
          color: #7f7f7f;
          margin-right: 55px;
        }
      }
    }
  }

  .jb-info-body {
    padding: 18px 20px;
    border-bottom: 1px solid #dbdbdb;
    .jb-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .title {
        font-size: 16px;
        font-weight: 400;
        color: #1c1c1c;
      }
      .edit-btn {
        margin-left: 23px;
        font-size: 16px;
        font-weight: 400;
        color: #3889c1;
        cursor: pointer;
      }
    }
    .jb-spk {
      font-size: 14px;
      font-weight: 400;
      color: rgba(175, 175, 175, 1);
      line-height: 23px;
      padding: 14px 0;
    }
    .jb-list-body {
      .flexStart();
      padding-bottom: 16px;
      img {
        width: 20px;
        height: 20px;
      }
      .title-img {
        margin-left: 22px;
        font-size: 16px;
        font-weight: bold;
        color: rgba(23, 23, 23, 1);
      }
      .title2-img {
        font-size: 16px;
        font-weight: 400;
        color: #7f7f7f;
        margin-left: 22px;
        .balck {
          color: #4d4d4d;
          font-size: 16px;
        }
      }
      .title-spk {
        font-size: 12px;
        color: #afafaf;
        margin-left: 14px;
      }
    }
    .jb-list-body:last-child {
      padding-bottom: 0;
    }

    .an-jk-list {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
      margin-left: 42px;
      .title {
        font-size: 16px;
        font-weight: 400;
        color: rgba(29, 29, 29, 1);
        padding-right: 23px;
        min-width: 64px;
      }

      .info {
        font-size: 14px;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 23px;
      }
    }
    .an-jk-list:last-child {
      margin-bottom: 0;
    }

    .show-content {
      font-size: 16px;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 20px;
      margin: 10px 0 38px 42px;
    }
    .show-content:last-child {
      margin: 10px 0 0px 42px;
    }
  }
  .keyword-body {
    border-bottom: 0;
    padding-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/infoEditInfo.vue